/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { RemoveAllValues } from './removeAllDialog-ng.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'remove-all-dialog',
    standalone: false,
})
export class RemoveAllDialogDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Input() resolve: RemoveAllValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('removeAllDialog', elementRef, injector);
    }
}
